// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Instrument+Sans:ital,wght@0,400..700;1,400..700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.donationHeader {
  position: fixed;
  width: 100%;
  transition: transform 0.3s ease-in-out;
  z-index: 100;

  /* Fluid and Zoom-resistant custom properties using CSS clamp and rem */
  --header-container-padding: 1.25rem clamp(1rem, 3vw, 4.8rem) 0 clamp(1rem, 3vw, 4.8rem);
  --header-container-gap: clamp(1rem, 2vw, 2.4rem);
  
  --logo-height: clamp(2.5rem, 3.44vw, 4.125rem); /* Scales from 40px to 66px */
  --logo-width: clamp(8.4375rem, 10.68vw, 12.8125rem); /* Scales from 135px to 205px */
  
  --nav-container-gap: clamp(0.5rem, 1.2vw, 1.5625rem); /* Scales from 8px to 25px */
  --nav-container-padding: clamp(0.4rem, 0.8vh, 0.54rem) clamp(0.6rem, 1vw, 1.2rem);
  --nav-font-size: clamp(0.7rem, 0.73vw, 0.875rem); /* Scales from 11px to 14px */
  
  --how-to-help-padding: clamp(0.3rem, 0.51vh, 0.344rem) clamp(0.5rem, 0.8vw, 1.25rem);
  --how-to-help-gap: clamp(0.25rem, 0.365vw, 0.4375rem);
  --how-to-help-text-size: clamp(0.7rem, 0.73vw, 0.875rem);
  --down-arrow-size: clamp(0.5rem, 0.73vw, 0.875rem); /* Scales from 8px to 14px */
  
  --btn-container-gap: clamp(0.375rem, 0.6vw, 0.625rem); /* 6px to 10px */
  --btn-padding: clamp(0.4rem, 0.6vw, 0.625rem) clamp(0.6rem, 1vw, 1.25rem); /* Scales down smoothly */
  --btn-font-size: clamp(0.7rem, 0.73vw, 0.875rem); /* Scales from 11px to 14px */
  --btn-margin-left: 0rem; /* Enforce 0rem to prevent pushing rightmost button offscreen */
  
  --back-hub-padding: clamp(0.4rem, 0.6vw, 0.5rem) clamp(0.6rem, 1vw, 1rem);
  --back-hub-font-size: clamp(0.7rem, 0.73vw, 0.8125rem);
  --back-hub-radius: 20px;
}

.donationHeader.hide {
  transform: translateY(-100%);
}

.donationHeader.show {
  transform: translateY(0);
}

.headerContainer {
  display: flex;
  gap: var(--header-container-gap);
  align-items: center;
  justify-content: space-between;
  padding: var(--header-container-padding);
  margin-top: 0; /* Always 0 to prevent the header from shifting down at any zoom/resolution */
  box-sizing: border-box;
}

.amalgamateLogo {
  height: var(--logo-height);
  width: var(--logo-width);
  object-fit: contain;
}

.headerTextsContainer {
  color: white;
  border: 1px solid rgba(135, 135, 135, 0.16);
  border-radius: 30px;
  background-color: rgba(20, 20, 20, 0.55);
}

.headerTextsContainer2 {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: var(--nav-container-gap);
  padding: var(--nav-container-padding);
}

.headerContainer a {
  all: unset;
  display: contents;
  cursor: pointer;
}

.headerText {
  white-space: nowrap;
  font-size: var(--nav-font-size);
  font-family: "Inter", sans-serif;
  margin: 0;
  font-weight: 200;
  display: inline;
}

.howToHelpContainer {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-sizing: border-box;
  background-color: #000000;
  border-radius: 30px;
}

.howToHelpContainer2 {
  padding: var(--how-to-help-padding);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--how-to-help-gap);
}

.howToHelpText {
  white-space: nowrap;
  background: linear-gradient(45deg, #48d1cc, #1e90ff);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  font-size: var(--how-to-help-text-size);
}

.howToHelpContainer::before {
  content: "";
  position: absolute;
  inset: 0;
  border-radius: 30px;
  padding: 2px;
  /* control the border thickness */
  background: linear-gradient(45deg, #48d1cc, #1e90ff);
  mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
  mask-composite: exclude;
  cursor: pointer;
}

.downArrow {
  height: var(--down-arrow-size);
  width: var(--down-arrow-size);
}

.donationGetTheAppText {
  color: black;
  font-weight: 600;
  font-family: "Instrument Sans", sans-serif;
  font-size: var(--btn-font-size);
}

.headerButtonsContainer {
  display: flex;
  gap: var(--btn-container-gap);
  align-items: center;
}

.donationLoginContainer {
  background: linear-gradient(45deg, #48d1cc, #1D4D41);
  border-radius: 12px;
  white-space: nowrap;
  padding: var(--btn-padding);
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: all 0.3s ease;
}

/* Back to Hub */
.donation-back-hub {
  background: transparent;
  border: 1px solid rgba(0, 229, 200, 0.55);
  border-radius: var(--back-hub-radius);
  padding: var(--back-hub-padding);
  font-size: var(--back-hub-font-size);
  font-weight: 600;
  letter-spacing: 0.5px;
  color: #00e5c8;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.2s, border-color 0.2s, color 0.2s;
  flex-shrink: 0;
}

.donation-back-hub:hover {
  background: rgba(0, 229, 200, 0.1);
  border-color: #00e5c8;
  color: #33edd5;
}

.donationLoginContainer:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(72, 209, 204, 0.3);
}

.donationLoginText {
  color: white;
  font-weight: 600;
  font-family: "Instrument Sans", sans-serif;
  font-size: var(--btn-font-size);
}

.donationGetTheAppContainer {
  background-color: #fff;
  border-radius: 12px;
  white-space: nowrap;
  padding: var(--btn-padding);
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-left: var(--btn-margin-left);
}

.donationGetTheAppContainer:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(255, 255, 255, 0.3);
}

.dialogText {
  font-family: "Inter", sans-serif;
  font-size: 0.75rem; /* 12px */
}

@media screen and (max-width: 1700px) {
  .donationHeader {
    --header-container-gap: clamp(1rem, 5vw, 10.625rem); /* Smooth scaling of the minimum gap */
  }
}

@media screen and (max-width: 1440px) {
  .donationHeader {
    --header-container-padding: 1.25rem clamp(1rem, 2vw, 3vw) 0 clamp(1rem, 2vw, 3vw);
    --btn-margin-left: 0rem; /* Reset margin-left to prevent offscreen push */
  }
}

@media screen and (max-width: 1024px) {
  .donationHeader {
    --logo-height: 1.80875rem;               /* 28.94px */
    --logo-width: 7.078125rem;               /* 113.25px */
    
    --header-container-gap: clamp(0.5rem, 2vw, 3.2rem);
    --header-container-padding: 1rem clamp(0.5rem, 1.5vw, 2vw) 0 clamp(0.5rem, 1.5vw, 2vw);
    
    --nav-font-size: 0.625rem;               /* 10px */
    --how-to-help-text-size: 0.75rem;        /* 12px */
    --down-arrow-size: 0.625rem;             /* 10px */
    
    --btn-container-gap: 0.384rem;           /* 0.6vw */
    
    --btn-padding: 0.576rem 0.768rem;        /* 1.2vh 1.2vw */
    --btn-font-size: 0.75rem;                /* 12px */
    --btn-margin-left: 0rem;                 /* Reset margin-left to prevent offscreen push */
  }
}

@media screen and (max-width: 768px) {
  .donationHeader {
    padding-left: 1rem;                      /* 16px */
    padding-right: 1rem;                     /* 16px */
    margin-top: 1.25rem;                     /* 20px */
    width: 100%;
    box-sizing: border-box;
  }

  .headerContainer {
    display: flex;
    align-items: center;
    margin-left: 0rem;
    justify-content: space-between;
    border: 1px solid #333333;
    margin-top: 0rem;
    border-radius: 10px;
    padding: 0.625rem;                       /* 10px */
    background-color: black;
    gap: 1rem;
  }

  .mobileMenuDropdown {
    background: rgba(20, 20, 20, 1);
    backdrop-filter: blur(5px);
  }

  .headerTextsContainer2 {
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    gap: 0.625rem;                           /* 1.302vw */
    padding: 1.5rem 1.5rem;                  /* 24px 24px */
  }

  .headerText {
    color: white;
    font-size: 0.75rem;                      /* 12px */
  }

  .amalgamateLogo {
    height: 1.885rem;                        /* 30.16px */
    width: 7.375rem;                         /* 118px */
  }

  .mobileMenuIcon {
    width: 3.125rem;                         /* 50px */
    height: 2.5rem;                          /* 40px */
  }

  .howToHelpContainer {
    border-radius: 1.875rem;                 /* 30px */
    margin-top: 0.625rem;                    /* 10px */
  }

  .howToHelpContainer::before {
    border-radius: 0.5rem;                   /* 8px */
    padding: 1px;
  }

  .accordionText {
    font-size: 0.625rem;                     /* 10px */
  }

  .donationLoginContainer {
    border-radius: 8px;
    margin-left: 0rem;
    margin-top: 0.625rem;                    /* 10px */
    width: 92%;
    padding: 0.75rem 0.96rem;                /* 1.5vh 2vw */
  }

  .donationLoginText {
    font-size: 0.7075rem;                    /* 11.32px */
    font-weight: 600;
  }

  .donationGetTheAppContainer {
    border-radius: 8px;
    margin-left: 0rem;
    margin-top: 0.625rem;                    /* 10px */
    width: 92%;
    padding: 0.75rem 0.96rem;                /* 1.5vh 2vw */
  }

  .donationGetTheAppText {
    font-size: 0.7075rem;                    /* 11.32px */
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/Donation/Header/Header.css"],"names":[],"mappings":"AAGA;EACE,eAAe;EACf,WAAW;EACX,sCAAsC;EACtC,YAAY;;EAEZ,uEAAuE;EACvE,uFAAuF;EACvF,gDAAgD;;EAEhD,8CAA8C,EAAE,6BAA6B;EAC7E,mDAAmD,EAAE,+BAA+B;;EAEpF,oDAAoD,EAAE,4BAA4B;EAClF,iFAAiF;EACjF,gDAAgD,EAAE,6BAA6B;;EAE/E,oFAAoF;EACpF,qDAAqD;EACrD,wDAAwD;EACxD,kDAAkD,EAAE,4BAA4B;;EAEhF,qDAAqD,EAAE,gBAAgB;EACvE,yEAAyE,EAAE,yBAAyB;EACpG,gDAAgD,EAAE,6BAA6B;EAC/E,uBAAuB,EAAE,+DAA+D;;EAExF,yEAAyE;EACzE,sDAAsD;EACtD,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,mBAAmB;EACnB,8BAA8B;EAC9B,wCAAwC;EACxC,aAAa,EAAE,6EAA6E;EAC5F,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,2CAA2C;EAC3C,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,6BAA6B;EAC7B,qCAAqC;AACvC;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;EAC/B,gCAAgC;EAChC,SAAS;EACT,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,oDAAoD;EACpD,6BAA6B;EAC7B,qBAAqB;EACrB,oCAAoC;EACpC,uCAAuC;AACzC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,mBAAmB;EACnB,YAAY;EACZ,iCAAiC;EACjC,oDAAoD;EACpD,sEAAsE;EAEtE,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,0CAA0C;EAC1C,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,oDAAoD;EACpD,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;EAC3B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;AAC3B;;AAEA,gBAAgB;AAChB;EACE,uBAAuB;EACvB,yCAAyC;EACzC,qCAAqC;EACrC,gCAAgC;EAChC,oCAAoC;EACpC,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,0DAA0D;EAC1D,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,0CAA0C;EAC1C,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;EAC3B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,mCAAmC;AACrC;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,gCAAgC;EAChC,kBAAkB,EAAE,SAAS;AAC/B;;AAEA;EACE;IACE,mDAAmD,EAAE,sCAAsC;EAC7F;AACF;;AAEA;EACE;IACE,iFAAiF;IACjF,uBAAuB,EAAE,gDAAgD;EAC3E;AACF;;AAEA;EACE;IACE,yBAAyB,gBAAgB,YAAY;IACrD,yBAAyB,gBAAgB,aAAa;;IAEtD,kDAAkD;IAClD,sFAAsF;;IAEtF,yBAAyB,gBAAgB,SAAS;IAClD,gCAAgC,SAAS,SAAS;IAClD,2BAA2B,cAAc,SAAS;;IAElD,6BAA6B,YAAY,UAAU;;IAEnD,gCAAgC,SAAS,gBAAgB;IACzD,wBAAwB,iBAAiB,SAAS;IAClD,uBAAuB,kBAAkB,gDAAgD;EAC3F;AACF;;AAEA;EACE;IACE,kBAAkB,uBAAuB,SAAS;IAClD,mBAAmB,sBAAsB,SAAS;IAClD,mBAAmB,sBAAsB,SAAS;IAClD,WAAW;IACX,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,8BAA8B;IAC9B,yBAAyB;IACzB,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB,wBAAwB,SAAS;IAClD,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,+BAA+B;IAC/B,0BAA0B;EAC5B;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,sBAAsB;IACtB,aAAa,4BAA4B,YAAY;IACrD,sBAAsB,mBAAmB,cAAc;EACzD;;EAEA;IACE,YAAY;IACZ,kBAAkB,uBAAuB,SAAS;EACpD;;EAEA;IACE,gBAAgB,yBAAyB,YAAY;IACrD,eAAe,0BAA0B,UAAU;EACrD;;EAEA;IACE,eAAe,0BAA0B,SAAS;IAClD,cAAc,2BAA2B,SAAS;EACpD;;EAEA;IACE,uBAAuB,kBAAkB,SAAS;IAClD,oBAAoB,qBAAqB,SAAS;EACpD;;EAEA;IACE,qBAAqB,oBAAoB,QAAQ;IACjD,YAAY;EACd;;EAEA;IACE,mBAAmB,sBAAsB,SAAS;EACpD;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,oBAAoB,qBAAqB,SAAS;IAClD,UAAU;IACV,wBAAwB,iBAAiB,cAAc;EACzD;;EAEA;IACE,oBAAoB,qBAAqB,YAAY;IACrD,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,oBAAoB,qBAAqB,SAAS;IAClD,UAAU;IACV,wBAAwB,iBAAiB,cAAc;EACzD;;EAEA;IACE,oBAAoB,qBAAqB,YAAY;EACvD;AACF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap\");\n@import url(\"https://fonts.googleapis.com/css2?family=Instrument+Sans:ital,wght@0,400..700;1,400..700&display=swap\");\n\n.donationHeader {\n  position: fixed;\n  width: 100%;\n  transition: transform 0.3s ease-in-out;\n  z-index: 100;\n\n  /* Fluid and Zoom-resistant custom properties using CSS clamp and rem */\n  --header-container-padding: 1.25rem clamp(1rem, 3vw, 4.8rem) 0 clamp(1rem, 3vw, 4.8rem);\n  --header-container-gap: clamp(1rem, 2vw, 2.4rem);\n  \n  --logo-height: clamp(2.5rem, 3.44vw, 4.125rem); /* Scales from 40px to 66px */\n  --logo-width: clamp(8.4375rem, 10.68vw, 12.8125rem); /* Scales from 135px to 205px */\n  \n  --nav-container-gap: clamp(0.5rem, 1.2vw, 1.5625rem); /* Scales from 8px to 25px */\n  --nav-container-padding: clamp(0.4rem, 0.8vh, 0.54rem) clamp(0.6rem, 1vw, 1.2rem);\n  --nav-font-size: clamp(0.7rem, 0.73vw, 0.875rem); /* Scales from 11px to 14px */\n  \n  --how-to-help-padding: clamp(0.3rem, 0.51vh, 0.344rem) clamp(0.5rem, 0.8vw, 1.25rem);\n  --how-to-help-gap: clamp(0.25rem, 0.365vw, 0.4375rem);\n  --how-to-help-text-size: clamp(0.7rem, 0.73vw, 0.875rem);\n  --down-arrow-size: clamp(0.5rem, 0.73vw, 0.875rem); /* Scales from 8px to 14px */\n  \n  --btn-container-gap: clamp(0.375rem, 0.6vw, 0.625rem); /* 6px to 10px */\n  --btn-padding: clamp(0.4rem, 0.6vw, 0.625rem) clamp(0.6rem, 1vw, 1.25rem); /* Scales down smoothly */\n  --btn-font-size: clamp(0.7rem, 0.73vw, 0.875rem); /* Scales from 11px to 14px */\n  --btn-margin-left: 0rem; /* Enforce 0rem to prevent pushing rightmost button offscreen */\n  \n  --back-hub-padding: clamp(0.4rem, 0.6vw, 0.5rem) clamp(0.6rem, 1vw, 1rem);\n  --back-hub-font-size: clamp(0.7rem, 0.73vw, 0.8125rem);\n  --back-hub-radius: 20px;\n}\n\n.donationHeader.hide {\n  transform: translateY(-100%);\n}\n\n.donationHeader.show {\n  transform: translateY(0);\n}\n\n.headerContainer {\n  display: flex;\n  gap: var(--header-container-gap);\n  align-items: center;\n  justify-content: space-between;\n  padding: var(--header-container-padding);\n  margin-top: 0; /* Always 0 to prevent the header from shifting down at any zoom/resolution */\n  box-sizing: border-box;\n}\n\n.amalgamateLogo {\n  height: var(--logo-height);\n  width: var(--logo-width);\n  object-fit: contain;\n}\n\n.headerTextsContainer {\n  color: white;\n  border: 1px solid rgba(135, 135, 135, 0.16);\n  border-radius: 30px;\n  background-color: rgba(20, 20, 20, 0.55);\n}\n\n.headerTextsContainer2 {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: var(--nav-container-gap);\n  padding: var(--nav-container-padding);\n}\n\n.headerContainer a {\n  all: unset;\n  display: contents;\n  cursor: pointer;\n}\n\n.headerText {\n  white-space: nowrap;\n  font-size: var(--nav-font-size);\n  font-family: \"Inter\", sans-serif;\n  margin: 0;\n  font-weight: 200;\n  display: inline;\n}\n\n.howToHelpContainer {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  box-sizing: border-box;\n  background-color: #000000;\n  border-radius: 30px;\n}\n\n.howToHelpContainer2 {\n  padding: var(--how-to-help-padding);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: var(--how-to-help-gap);\n}\n\n.howToHelpText {\n  white-space: nowrap;\n  background: linear-gradient(45deg, #48d1cc, #1e90ff);\n  -webkit-background-clip: text;\n  background-clip: text;\n  -webkit-text-fill-color: transparent;\n  font-size: var(--how-to-help-text-size);\n}\n\n.howToHelpContainer::before {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  border-radius: 30px;\n  padding: 2px;\n  /* control the border thickness */\n  background: linear-gradient(45deg, #48d1cc, #1e90ff);\n  mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);\n  -webkit-mask-composite: xor;\n  mask-composite: exclude;\n  cursor: pointer;\n}\n\n.downArrow {\n  height: var(--down-arrow-size);\n  width: var(--down-arrow-size);\n}\n\n.donationGetTheAppText {\n  color: black;\n  font-weight: 600;\n  font-family: \"Instrument Sans\", sans-serif;\n  font-size: var(--btn-font-size);\n}\n\n.headerButtonsContainer {\n  display: flex;\n  gap: var(--btn-container-gap);\n  align-items: center;\n}\n\n.donationLoginContainer {\n  background: linear-gradient(45deg, #48d1cc, #1D4D41);\n  border-radius: 12px;\n  white-space: nowrap;\n  padding: var(--btn-padding);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n/* Back to Hub */\n.donation-back-hub {\n  background: transparent;\n  border: 1px solid rgba(0, 229, 200, 0.55);\n  border-radius: var(--back-hub-radius);\n  padding: var(--back-hub-padding);\n  font-size: var(--back-hub-font-size);\n  font-weight: 600;\n  letter-spacing: 0.5px;\n  color: #00e5c8;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: background 0.2s, border-color 0.2s, color 0.2s;\n  flex-shrink: 0;\n}\n\n.donation-back-hub:hover {\n  background: rgba(0, 229, 200, 0.1);\n  border-color: #00e5c8;\n  color: #33edd5;\n}\n\n.donationLoginContainer:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(72, 209, 204, 0.3);\n}\n\n.donationLoginText {\n  color: white;\n  font-weight: 600;\n  font-family: \"Instrument Sans\", sans-serif;\n  font-size: var(--btn-font-size);\n}\n\n.donationGetTheAppContainer {\n  background-color: #fff;\n  border-radius: 12px;\n  white-space: nowrap;\n  padding: var(--btn-padding);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  margin-left: var(--btn-margin-left);\n}\n\n.donationGetTheAppContainer:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(255, 255, 255, 0.3);\n}\n\n.dialogText {\n  font-family: \"Inter\", sans-serif;\n  font-size: 0.75rem; /* 12px */\n}\n\n@media screen and (max-width: 1700px) {\n  .donationHeader {\n    --header-container-gap: clamp(1rem, 5vw, 10.625rem); /* Smooth scaling of the minimum gap */\n  }\n}\n\n@media screen and (max-width: 1440px) {\n  .donationHeader {\n    --header-container-padding: 1.25rem clamp(1rem, 2vw, 3vw) 0 clamp(1rem, 2vw, 3vw);\n    --btn-margin-left: 0rem; /* Reset margin-left to prevent offscreen push */\n  }\n}\n\n@media screen and (max-width: 1024px) {\n  .donationHeader {\n    --logo-height: 1.80875rem;               /* 28.94px */\n    --logo-width: 7.078125rem;               /* 113.25px */\n    \n    --header-container-gap: clamp(0.5rem, 2vw, 3.2rem);\n    --header-container-padding: 1rem clamp(0.5rem, 1.5vw, 2vw) 0 clamp(0.5rem, 1.5vw, 2vw);\n    \n    --nav-font-size: 0.625rem;               /* 10px */\n    --how-to-help-text-size: 0.75rem;        /* 12px */\n    --down-arrow-size: 0.625rem;             /* 10px */\n    \n    --btn-container-gap: 0.384rem;           /* 0.6vw */\n    \n    --btn-padding: 0.576rem 0.768rem;        /* 1.2vh 1.2vw */\n    --btn-font-size: 0.75rem;                /* 12px */\n    --btn-margin-left: 0rem;                 /* Reset margin-left to prevent offscreen push */\n  }\n}\n\n@media screen and (max-width: 768px) {\n  .donationHeader {\n    padding-left: 1rem;                      /* 16px */\n    padding-right: 1rem;                     /* 16px */\n    margin-top: 1.25rem;                     /* 20px */\n    width: 100%;\n    box-sizing: border-box;\n  }\n\n  .headerContainer {\n    display: flex;\n    align-items: center;\n    margin-left: 0rem;\n    justify-content: space-between;\n    border: 1px solid #333333;\n    margin-top: 0rem;\n    border-radius: 10px;\n    padding: 0.625rem;                       /* 10px */\n    background-color: black;\n    gap: 1rem;\n  }\n\n  .mobileMenuDropdown {\n    background: rgba(20, 20, 20, 1);\n    backdrop-filter: blur(5px);\n  }\n\n  .headerTextsContainer2 {\n    display: flex;\n    align-items: flex-start;\n    flex-direction: column;\n    gap: 0.625rem;                           /* 1.302vw */\n    padding: 1.5rem 1.5rem;                  /* 24px 24px */\n  }\n\n  .headerText {\n    color: white;\n    font-size: 0.75rem;                      /* 12px */\n  }\n\n  .amalgamateLogo {\n    height: 1.885rem;                        /* 30.16px */\n    width: 7.375rem;                         /* 118px */\n  }\n\n  .mobileMenuIcon {\n    width: 3.125rem;                         /* 50px */\n    height: 2.5rem;                          /* 40px */\n  }\n\n  .howToHelpContainer {\n    border-radius: 1.875rem;                 /* 30px */\n    margin-top: 0.625rem;                    /* 10px */\n  }\n\n  .howToHelpContainer::before {\n    border-radius: 0.5rem;                   /* 8px */\n    padding: 1px;\n  }\n\n  .accordionText {\n    font-size: 0.625rem;                     /* 10px */\n  }\n\n  .donationLoginContainer {\n    border-radius: 8px;\n    margin-left: 0rem;\n    margin-top: 0.625rem;                    /* 10px */\n    width: 92%;\n    padding: 0.75rem 0.96rem;                /* 1.5vh 2vw */\n  }\n\n  .donationLoginText {\n    font-size: 0.7075rem;                    /* 11.32px */\n    font-weight: 600;\n  }\n\n  .donationGetTheAppContainer {\n    border-radius: 8px;\n    margin-left: 0rem;\n    margin-top: 0.625rem;                    /* 10px */\n    width: 92%;\n    padding: 0.75rem 0.96rem;                /* 1.5vh 2vw */\n  }\n\n  .donationGetTheAppText {\n    font-size: 0.7075rem;                    /* 11.32px */\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
